import { render, staticRenderFns } from "./OnBoardingHeader.vue?vue&type=template&id=09b5632f&scoped=true&"
import script from "./OnBoardingHeader.vue?vue&type=script&lang=js&"
export * from "./OnBoardingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5632f",
  null
  
)

export default component.exports